export const CheckDecimal = (n:any) => {
	if (parseInt(n) > 0) {
		var result = n - Math.floor(n) !== 0;
		if (result) {
			return n.toFixed(2);
		} else {
			return n;
		}
	} else {
		return 0;
	}
};
